import { NS_SERVICES, API, PROJECT } from 'redux/constants';
import { createType, FETCH, fetchCreator } from 'redux-create-type';

export const {
  GET_LIST,
  GET,
  GET_TEMPLATE,
  GET_ITEMS_CONFIGURATION,
  UPDATE_ITEMS_CONFIGURATION,
  GET_STATUSES,
  UPSERT_STATUS,
  GET_TAGS,
  UPSERT_TAGS,
  GET_BOARDS,
  UPSERT_BOARD,
  GET_CATEGORIES,
  UPSERT_CATEGORY,
  UPSERT,
  GET_TEMPLATES,
  UPSERT_TEMPLATE,
  GET_IS_PROJECT_NAME_UNIQUE,
} = createType(NS_SERVICES, API, PROJECT)({
    GET_LIST: FETCH,
    GET: FETCH,
    GET_TEMPLATE: FETCH,
    GET_ITEMS_CONFIGURATION: FETCH,
    UPDATE_ITEMS_CONFIGURATION: FETCH,
    GET_STATUSES: FETCH,
    UPSERT_STATUS: FETCH,
    GET_TAGS: FETCH,
    UPSERT_TAGS: FETCH,
    GET_BOARDS: FETCH,
    UPSERT_BOARD: FETCH,
    GET_CATEGORIES: FETCH,
    UPSERT_CATEGORY: FETCH,
    UPSERT: FETCH,
    GET_TEMPLATES: FETCH,
    UPSERT_TEMPLATE: FETCH,
    GET_IS_PROJECT_NAME_UNIQUE: FETCH
  });

export const getList = fetchCreator(GET_LIST);
export const get = fetchCreator(GET);
export const getTemplate = fetchCreator(GET_TEMPLATE);
export const getItemsConfiguration = fetchCreator(GET_ITEMS_CONFIGURATION);
export const updateItemsConfiguration = fetchCreator(UPDATE_ITEMS_CONFIGURATION);
export const getStatuses = fetchCreator(GET_STATUSES);
export const upsertStatus = fetchCreator(UPSERT_STATUS);
export const getTags = fetchCreator(GET_TAGS);
export const upsertTags = fetchCreator(UPSERT_TAGS);
export const getBoards = fetchCreator(GET_BOARDS);
export const upsertBoard = fetchCreator(UPSERT_BOARD);
export const getCategories = fetchCreator(GET_CATEGORIES);
export const upsertCategory = fetchCreator(UPSERT_CATEGORY);
export const upsert = fetchCreator(UPSERT);
export const getTemplates = fetchCreator(GET_TEMPLATES);
export const upsertTemplate = fetchCreator(UPSERT_TEMPLATE);
export const getIsProjectNameUnique = fetchCreator(GET_IS_PROJECT_NAME_UNIQUE);


// WEBPACK FOOTER //
// ../redux/store/services/api/configuration/project/actions.js